import * as React from 'react';

import GenericIconProps from './_icon.type';

function CheckIcon({ className }: GenericIconProps) {
  return (
    <svg
      className={className || ''}
      width="20"
      height="20"
      viewBox="-3 -3 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.13132 9.46756L1.04946 5.73602L0 6.99776L4.13132 12L13 1.26174L11.9579 0L4.13132 9.46756Z" />
    </svg>
  );
}

export default CheckIcon;
